import { PillTabs } from 'components/FbUI/PillTabs'
import React from 'react'
import { TabKey, useOpportunitiesContext } from './opportunities-context'

const OpportunitiesTabs: React.FC = () => {
  const { setSelectedTab, selectedTag, noKnownRecords } =
    useOpportunitiesContext()

  const tabs = noKnownRecords
    ? ([
        { key: 'custom-companies', title: 'Custom Companies' },
        { key: 'custom-locations', title: 'Custom Locations' },
      ] as const)
    : ([
        { key: 'fb-companies', title: 'FB Companies' },
        { key: 'fb-locations', title: 'FB Locations' },
        { key: 'custom-companies', title: 'Custom Companies' },
        { key: 'custom-locations', title: 'Custom Locations' },
      ] as const)

  return (
    <PillTabs<TabKey>
      tabs={tabs}
      activeKey={selectedTag}
      onChange={(t) => setSelectedTab(t)}
      idPrefix="opportunities"
      aria-label="Target type"
      size="sm"
      className="w-fit"
    />
  )
}

export default OpportunitiesTabs
